<template>
  <form class="c-form">
    <inline-label type="danger" v-if="currentUser.blocked"
      >This user has been blocked</inline-label
    >
    <form-field
      full-width
      label="Name"
      required
      v-model="currentUser.name"
      v-validate="{ required: true }"
      data-vv-as="name"
      name="name"
      :error="errors.first('name')"
    ></form-field>

    <form-field
      full-width
      label="Email Address"
      name="email"
      type="email"
      v-model="currentUser.email"
      v-validate="{ required: true, email: true }"
      data-vv-as="email"
      required
      :error="errors.first('email')"
    ></form-field>

    <form-field
      full-width
      :label="editMode ? 'Edit Password' : 'Create password'"
      name="user_password"
      v-model="currentUser.password"
      type="password"
      :required="!editMode"
      withButton
      buttonText="Generate"
      @click="generatePassword"
    />
    <message v-if="generatedPassword" type="warning">
      <p>The password generated is</p>
      <code>{{ generatedPassword }}</code>
      <p>
        Please make sure you have stored this password before saving this form.
      </p>
      <base-button @click="copyPassword" type="button"
        >Copy to clipboard</base-button
      >
    </message>
    <form-field
      full-width
      label="Confirm Password"
      name="user_password_confirm"
      v-model="userPasswordConfirm"
      type="password"
      :required="!editMode"
      v-validate="{ is: currentUser.password }"
      data-vv-name="Password confirm"
      :error="errors.first('user_password_confirm')"
    />

    <p
      v-if="userPasswordConfirm && userPasswordConfirm != currentUser.password"
    >
      <inline-label type="danger">Passwords do not match</inline-label>
    </p>

    <!-- <div>
      <ul>
        <li v-for="(value, key, index) in userPrivileges">{{ key }}: {{ value }}</li>
      </ul>
    </div>-->
    <fieldset>
      <legend>User groups</legend>

      <ul>
        <li>
          <input type="checkbox" @change="toggleGroup" id="toggleAllGroups" />
          {{ " " }}
          <label for="toggleAllGroups">Toggle All</label>
        </li>
        <li>
          <input
            type="checkbox"
            @change="toggleSuper"
            id="toggleSuper"
            v-model="isSuperAdmin"
          />
          {{ " " }}
          <label for="toggleSuper">Super Admin</label>
        </li>
        <li
          v-for="(value, key, index) in currentUser.privilege_groups"
          :key="index"
        >
          <input
            type="checkbox"
            :id="key"
            :name="key"
            v-model="currentUser.privilege_groups[key]"
            :disabled="isSuperAdmin"
          />
          {{ " " }}
          <label :for="key">{{ key | titleCase }}</label>
        </li>
      </ul>
    </fieldset>
  </form>
</template>

<script>
import { mapState } from "vuex";
import { InlineLabel } from "@/components/elements";
export default {
  name: "user-form",

  components: {
    InlineLabel,
  },

  methods: {
    toggleGroup(el) {
      // set the state, not the checkbox
      const checkedState = el.target.checked;
      // const list = el.target.parentElement.parentElement;
      Object.keys(this.currentUser.privilege_groups).forEach((grp) => {
        this.currentUser.privilege_groups[grp] = checkedState;
      });
    },
    toggleSuper() {},
    generatePassword() {
      const password =
        Math.random()
          .toString(36)
          .substring(2, 10) +
        Math.random()
          .toString(36)
          .substring(2, 10);
      this.generatedPassword = password;
      this.currentUser.password = password;
    },
    copyPassword() {
      const text = this.generatedPassword;
      const vm = this;
      if (!text) {
        alert("Please generate a password first");
      }
      if (!navigator.clipboard) {
        this.fallbackCopyTextToClipboard(text);
        return;
      }
      navigator.clipboard.writeText(text).then(
        function() {
          vm.$store.dispatch("notifications/create", {
            body: `Password has been copied.`,
            type: "success",
          });
        },
        function(err) {
          vm.$store.dispatch("notifications/create", {
            body: `Could not copy password.  Please try this manually.`,
            type: "error",
          });
        }
      );
    },
    fallbackCopyTextToClipboard(text) {
      var textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        var successful = document.execCommand("copy");
        vm.$store.dispatch("notifications/create", {
          body: `Password has been copied.`,
          type: "success",
        });
      } catch (err) {
        vm.$store.dispatch("notifications/create", {
          body: `Could not copy password.  Please try this manually.`,
          type: "error",
        });
      }

      document.body.removeChild(textArea);
    },
  },

  computed: {
    ...mapState("users", ["currentUser"]),
    isSuperAdmin: {
      get() {
        // TODO: For now assume that people with all groups are super people
        const groups = this.currentUser.privilege_groups;
        let superAdmin = true;
        Object.keys(groups).forEach((val, grp) => {
          if (!groups[val]) {
            superAdmin = false;
          }
        });
        this.currentUser.superAdmin = superAdmin;
        return superAdmin;
      },
      set(newVal) {
        Object.keys(this.currentUser.privilege_groups).forEach((grp) => {
          this.currentUser.privilege_groups[grp] = newVal;
        });
        const checks = document.querySelectorAll(
          '[type="checkbox"]:not(#toggleSuper):not(#toggleAllGroups)'
        );

        checks.forEach((chk) => {
          chk.disabled = newVal;
        });
        this.currentUser.superAdmin = newVal;
      },
    },
  },
  data() {
    return {
      editMode: this.$route.params.userId ? true : false,
      generatedPassword: "",
      userPasswordConfirm: "",
    };
  },
};
</script>

<style lang="scss" scoped>
ul,
li {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
li {
  line-height: 1.2;
  margin: 5px 0 0;
}
label {
  text-transform: capitalize;
}

code {
  margin: 0 auto;
  display: inline-block;
  background: $colour-nhs-pale-grey;
  color: $colour-nhs-black;
  padding: 5px 10px;
  font-size: 1.25rem;
}
</style>
